import { css } from 'styled-components';
import { ButtonProps } from '@mui/material';
import { ButtonSize } from './types';

type StyleProps = ButtonProps & { $size?: ButtonSize };

const buttonStyles = css<StyleProps>`
  text-transform: none;
  box-shadow: none;
  font-weight: ${({ theme, $size }) =>
    $size === 'large' ? theme.typography.fontWeightBold : 500};
  font-size: ${({ $size }) =>
    $size === 'extraSmall' ? '12px' : $size === 'large' ? '16px' : '14px'};
  height: ${({ $size }) =>
    $size === 'extraSmall' ? '28px' : $size === 'large' ? '40px' : '32px'};
  padding: ${({ $size }) =>
    $size === 'extraSmall'
      ? '4px 8px'
      : $size === 'large'
      ? '10px 16px'
      : '6px 10px'};
  border-radius: 8px;
  white-space: nowrap;

  &:hover {
    box-shadow: none;
  }

  :disabled {
    svg > path {
      fill: ${({ theme }) => theme.palette.common.gray11};
    }
  }

  ${({ theme, variant, color }) => {
    if (variant === 'contained') {
      if (color === 'primary') {
        return `
          background: ${theme.palette.primary.main};
          color: ${theme.palette.common.white};
          border: none;
          :disabled {
            background: ${theme.palette.common.gray8};
            color:  ${theme.palette.common.gray11};
          }
        `;
      }
      if (color === 'secondary') {
        return `
          background: ${theme.palette.common.white};
          border: none;
          color: ${theme.palette.common.black};
          :hover {
            background: ${theme.palette.common.gray8};
          }
          :disabled {
            background: ${theme.palette.common.white};
            color:  ${theme.palette.common.gray11};
          }
        `;
      }
      if (color === 'error') {
        return `
          background: ${theme.palette.error.main};
          border: none;
          color: ${theme.palette.common.white};
          :hover {
            background: ${theme.palette.error.main};
            filter: brightness(110%);
          }
        `;
      }
    }

    if (variant === 'outlined') {
      if (color === 'primary') {
        return `
          background:  ${theme.palette.common.white};
          border-color: ${theme.palette.common.gray7} ;
          color: ${theme.palette.common.black};
          :hover {
            background: ${theme.palette.common.gray8};
            border-color: ${theme.palette.common.gray7} ;
          }
          :disabled {
            background: ${theme.palette.common.gray10};
            color:  ${theme.palette.common.gray11};
          }
        `;
      }
      if (color === 'secondary') {
        return `
          background:  ${theme.palette.common.gray3};
          border-color: ${theme.palette.common.gray7};
          color: ${theme.palette.common.black};
          :hover {
            border-color: ${theme.palette.common.black};
            background: ${theme.palette.common.gray3};
          }
        `;
      }
    }

    if (variant === 'text') {
      if (color === 'primary') {
        return `
          background: none;
          border: none;
          :hover {
            background: none;
          }
      `;
      }
      if (color === 'secondary') {
        return `
        background: none;
        border: none;
        color:  ${theme.palette.common.black};
        :hover {
          background: none;
        }
    `;
      }
    }

    return ``;
  }}
`;

export default buttonStyles;
